export const getModelPerfil = () => ({
    iIdPerfil: 0,
});

export const getFormPerfil = () => ({
    txtIdPerfil: {
        label: "ID de perfil:",
        required: false,
        value: "",
        error: false,
        message: "El ID del perfil es requerido",
    },
    txtNombrePerfil: {
        label: "Nombre de perfil:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del perfil es requerido",
    },
});

export const getPerfilColumns = () => [
    { title: "ID Perfil", field: "iIdPerfil" },
    { title: "Descripción", field: "sNombre" },
];
